import Vue from "vue";

import websocket from "@/utils/websocket/index";
export const exercise = {
  methods: {
    //获取流程下的小组
    async getExerciseGroup(sceneId) {
      let res = await this.$http.get(`/tenant/emergency/flow/group/list`,{
        sceneId:sceneId
      });
      return res;
    },
    //获取小组下的角色
    async getExerciseRole(sceneId,groupId) {
      let res = await this.$http.get(`/tenant/emergency/flow/group/role/list`,{
        sceneId:sceneId,
        groupId:groupId
      });
      return res;
    },
   //开始演练
    async startExercise(obj) {
      let res = await this.$http.post("/tenant/emergency/drill/start", obj);
      return res;
    },
    //下一步演练
    async nextExercise(obj) {
      let res = await this.$http.post("/tenant/emergency/drill/next", obj);
      return res;
    },
    //结束演练（单人）
    async endExercise(obj) {
      let res = await this.$http.post("/tenant/emergency/drill/end", obj);
      return res;
    },

    //结束演练(多人)
    async peopelExEnd(obj){
      let res = await this.$http.post("/tenant/emergency/room/end",obj);
      return res;
    }
  },
};
